import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import SelectChannel from '../../components/SelectChannel.vue'
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import { useStore } from '@/store'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelAddDot',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const store = useStore()
    const filters = reactive({
        channel_no:'',
        add_little:'',
        start_time:'',
        end_time:'',
        page:        1,      // 当前页码
        page_size:          10,     // 每页显示条数
    })

    const tableData = ref([])
    const total = ref(0)
    const state = reactive ({
        dialogVisibleFile : false,
    })
    const out = (type) => {
        window.open(`${Keys.baseUrl}/coupon/offline_coupon/warehouseOutboundList?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export=${type}`)
    }
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/coupon/offline_coupon/get_channe_add_little_list', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    const toAdd = (t) => {
        router.push(`/coupon-iso/channel_dot_edit?t=${t}`)
    }
    const toChannelDot = (row,t) => {
        const { channel_no, channel_name, add_little} = row
        router.push(`/coupon-iso/channel_dot_edit?channel_no=${channel_no}&channel_name=${channel_name}&t=${t}&add_little=${add_little}`)
    }
    // 渠道变化监听
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no : ''
    }
     //删除渠道
     const onDelete = (id) => {
        proxy.$confirm('是否确认删除', '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/coupon/offline_coupon/del_channe_coupon_add_little',{id,type:1}).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '删除成功' })
            getList()
        })
        }).catch(() => {
            console.log('取消')
        })
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.add_little,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.add_little) = $event)),
        modelModifiers: { trim: true },
        placeholder: "加点",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.start_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.end_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (toAdd(1)))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("新增")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道"
        }),
        _createVNode(_component_el_table_column, {
          prop: "msg",
          label: "加点"
        }),
        _createVNode(_component_el_table_column, {
          prop: "update_time",
          label: "更新时间"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                disabled: scope.row.return_time,
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toChannelDot(scope.row,2))
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" 渠道加点配置 ")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (onDelete(scope.row.id))
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" 删除 ")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})